import React from "react";
import { ProgressBarContainer, Track, Bar, TrackWrapper } from "./styles";

function ProgressBar({ percent, type = "normal", currentStep }) {
  const ProgressBar = [
    {
      name: "New Program",
      currentStep: currentStep,
      type: type,
    },
    {
      name: "Program Managers",
      currentStep: currentStep,
      type: type,
    },
    {
      name: "Application",
      currentStep: currentStep,
      type: type,
    },
  ];
  return (
    <ProgressBarContainer>
      {ProgressBar.map((item, index) => {
        const percent = index <= currentStep ? 100 : 0;
        const setColor = index <= currentStep ? "#44449B" : "#A7A5A5";
        return (
          <TrackWrapper key={index} currentStep={currentStep}>
            <Track>
              <Bar percent={percent} type={item.type} />
              <span style={{ color: setColor }}>{item.name}</span>
            </Track>
          </TrackWrapper>
        );
      })}
    </ProgressBarContainer>
  );
}
export default ProgressBar;
